import Page from "../../components/Page/Page";
import IconBox from "../../components/IconBox";
import { Button, Row, Col, Modal } from "antd";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import PagesData from "../../constants/pageData";

import Classes from "./index.module.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useEffect, useState } from "react";

const Chartdata = [
  { name: "صفحه A", uv: 4000, price: 2400, amt: 2400 },
  { name: "صفحه B", uv: 3000, price: 1398, amt: 2210 },
  { name: "صفحه C", uv: 2000, price: 9800, amt: 2290 },
  { name: "صفحه D", uv: 2780, price: 3908, amt: 2000 },
  { name: "صفحه E", uv: 1890, price: 4800, amt: 2181 },
  { name: "صفحه F", uv: 2390, price: 3800, amt: 2500 },
  { name: "صفحه G", uv: 3490, price: 4300, amt: 2100 },
];

export default function HomePage() {
  const [groupeditems, setGroupedItems] = useState([]);
  useEffect(()=>{
    const items = [];
    Object.keys(PagesData).forEach((key) => {
      const data = PagesData[key];
  
      if (Array.isArray(data)) {
        // If it's an array (like 'Home'), iterate over its elements
        data.forEach((item) => {
          if(item.id != "home"){
          items.push(
              <IconBox
                to={item.url}
                ke={item.id}
                icon={item.icon}
                text={item.title}
                width={33}
              />
          );
        }
        });
      } else {
        // If it's a single object (like 'Map', 'Maketerlocation', etc.)
        if(data.id != "home"){
        items.push(

            <IconBox
              to={data.url}
              ke={data.id}
              icon={data.icon}
              text={data.title}
              width={33}
            />

        );
      }
      }
    });
  
    // Group items into rows of three
    const gI = [];
    for (let i = 0; i < items.length; i += 3) {
      gI.push(
        <Row key={i} className={Classes.middleRow}>
          {items.slice(i, i + 3)}
        </Row>
      );
    }
setGroupedItems(gI)
  },[])
  const history=useHistory();
  function goto(destination){
    history.push(destination);
  }
  return (
    <Page>
      <Row>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart
            data={Chartdata}
            margin={{ top: 10, right: 0, left: -35, bottom: 0 }}
          >
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Line
              type="natural"
              dataKey="price"
              stroke="#003366"
              activeDot={{ r: 8 }}
            />
            <Line type="monotone" dataKey="uv" stroke="#FE9E15" />
          </LineChart>
        </ResponsiveContainer>
      </Row>
      {groupeditems}
      {/* <Row className={Classes.middleRow}>
        <IconBox
          to={PagesData.Map.url}
          ke={PagesData.Map.id}
          icon={PagesData.Map.icon}
          text={PagesData.Map.title}
          width={33}
        />
        <IconBox
          to={PagesData.Maketerlocation.url}
          ke={PagesData.Maketerlocation.id}
          icon={PagesData.Maketerlocation.icon}
          text={PagesData.Maketerlocation.title}
          width={33}
        />
        <IconBox
          to={PagesData.AccountBalance.url}
          ke={PagesData.AccountBalance.id}
          icon={PagesData.AccountBalance.icon}
          text={PagesData.AccountBalance.title}
          width={33}
        />
      </Row>
      <Row className={Classes.middleRow}>
        <IconBox
          to={PagesData.Map.url}
          ke={PagesData.Map.id}
          icon={PagesData.Map.icon}
          text={PagesData.Map.title}
          width={33}
        />
        <IconBox
          to={PagesData.Maketerlocation.url}
          ke={PagesData.Maketerlocation.id}
          icon={PagesData.Maketerlocation.icon}
          text={PagesData.Maketerlocation.title}
          width={33}
        />
        <IconBox
          to={PagesData.AccountBalance.url}
          ke={PagesData.AccountBalance.id}
          icon={PagesData.AccountBalance.icon}
          text={PagesData.AccountBalance.title}
          width={33}
        />
      </Row>
      <Row className={Classes.middleRow}>
        <IconBox
          to={PagesData.Map.url}
          ke={PagesData.Map.id}
          icon={PagesData.Map.icon}
          text={PagesData.Map.title}
          width={33}
        />
        <IconBox
          to={PagesData.Maketerlocation.url}
          ke={PagesData.Maketerlocation.id}
          icon={PagesData.Maketerlocation.icon}
          text={PagesData.Maketerlocation.title}
          width={33}
        />
        <IconBox
          to={PagesData.AccountBalance.url}
          ke={PagesData.AccountBalance.id}
          icon={PagesData.AccountBalance.icon}
          text={PagesData.AccountBalance.title}
          width={33}
        />
      </Row> */}
      {/* <Row className={Classes.thirdRow}>
        <div className={Classes.half}>
          <span>درخواست: {0}</span>
          <span>تخفیف: {0}</span>
          <span>کسورات: {0}</span>
          <span>خالص: {0}</span>
          <Button type="primary" className={Classes.button} onClick={()=>{goto("request")}}>
            ثبت درخواست
          </Button>
        </div>
        <div className={Classes.half}>
          <span>نقدی: {0}</span>
          <span>چک: {0}</span>
          <span>حواله: {0}</span>
          <span>دریافتی: {0}</span>
          <Button type="primary" className={Classes.button} onClick={()=>{goto("payment")}}>
            ثبت دریافتی
          </Button>
        </div>
      </Row> */}
    </Page>
  );
}
